import React from 'react'
import './components/navigationbar.css'
import { Tab, Tabs } from 'react-bootstrap'

export const SwotPlan = () => (
  <>
    <div className="hero">
      <h1>SWOT Analysis</h1>
    </div>
    <section className="hero is-fullheight mb-5">
      <div className="columns">
        <div className="column is-one-fifth fadeLeftMini"></div>
        <div className="column is-vcentered">
          <Tabs defaultActiveKey="first" id="uncontrolled-tab-example">
            <Tab eventKey="first" title="Current Status (18 Months Operating)">
              <p>
                <h6>Strengths:</h6>
                <li>
                Established major retail partnership contract (under NDA) providing 
                immediate revenue opportunity and market validation.
                </li>
                <li>
                18-month operational track record demonstrating service delivery 
                capability and business viability.
                </li>
                <li>
                Zero-carbon waterless technology positioning aligned with growing 
                environmental consciousness trends.
                </li>
                <li>
                Premium service pricing (£25-£330) with PureShield ceramic protection 
                technology differentiation.
                </li>
                <li>
                Active fuel retailer partnership negotiations with major industry 
                player providing expansion potential.
                </li>
              </p>
              <p>
                <h6>Weaknesses:</h6>
                <li>
                Limited operational scale requiring investment to fulfill 
                partnership contract obligations.
                </li>
                <li>
                Geographic concentration in Surrey & Greater London limiting 
                market reach without expansion capital.
                </li>
                <li>
                Partnership dependency creating revenue concentration risk 
                if major contracts are lost.
                </li>
                <li>
                Small team size limiting capacity to handle multiple large 
                B2B contracts simultaneously.
                </li>
                <li>
                Limited marketing presence due to focus on B2B partnerships 
                rather than consumer acquisition.
                </li>
              </p>
              <p>
                <h6>Opportunities:</h6>
                <li>
                Immediate revenue potential from executing established retail 
                partnership contract with investment funding.
                </li>
                <li>
                Fuel retailer partnership finalization could significantly 
                increase revenue and market presence.
                </li>
                <li>
                Automotive dealer relationships provide foundation for 
                additional B2B contract development.
                </li>
                <li>
                Growing demand for eco-friendly automotive services aligns 
                with zero-carbon positioning.
                </li>
                <li>
                Investment funding enables scaling to capture established 
                partnership opportunities.
                </li>
              </p>
              <p>
                <h6>Threats:</h6>
                <li>
                Partnership contract loss could significantly impact revenue 
                given current business concentration.
                </li>
                <li>
                Economic downturn affecting commercial spending on automotive 
                services and partnership budgets.
                </li>
                <li>
                Seasonal variations in outdoor automotive service demand 
                affecting cash flow predictability.
                </li>
                <li>
                Competition from established car wash chains with greater 
                resources and market presence.
                </li>
                <li>
                Inability to secure adequate investment funding limiting 
                capacity to fulfill partnership obligations.
                </li>
              </p>
            </Tab>
            <Tab eventKey="fifth" title="3-Year Projection (Post-Investment)">
              <p>
                <h6>Strengths:</h6>
                <li>
                Proven partnership execution model with major retail and fuel 
                retailers demonstrating scalable B2B capability.
                </li>
                <li>
                Established operational procedures and quality control systems 
                developed through successful partnership fulfillment.
                </li>
                <li>
                Market leadership position in zero-carbon waterless automotive 
                care within Surrey & Greater London region.
                </li>
                <li>
                Strong financial performance with £200,000-£300,000 annual revenue 
                achieved through optimized partnership operations.
                </li>
                <li>
                Documented business model ready for selective franchise or 
                licensing opportunities based on proven performance.
                </li>
              </p>
              <p>
                <h6>Weaknesses:</h6>
                <li>
                Continued geographic concentration limiting growth potential 
                without significant expansion investment.
                </li>
                <li>
                Partnership dependency remains significant revenue risk despite 
                diversification efforts over 3-year period.
                </li>
                <li>
                Limited brand recognition outside established B2B partnership 
                network affecting direct consumer market penetration.
                </li>
                <li>
                Seasonal business variations continue to impact cash flow 
                predictability despite service portfolio expansion.
                </li>
              </p>
              <p>
                <h6>Opportunities:</h6>
                <li>
                Franchise or licensing model development based on proven 
                operational performance and financial stability.
                </li>
                <li>
                Geographic expansion within UK market leveraging established 
                partnership success and operational expertise.
                </li>
                <li>
                Strategic acquisition opportunities within automotive care sector 
                to accelerate growth and market presence.
                </li>
                <li>
                Technology integration opportunities for enhanced operational 
                efficiency and competitive differentiation.
                </li>
                <li>
                Additional commercial partnerships based on demonstrated 
                service delivery capability and market reputation.
                </li>
              </p>
              <p>
                <h6>Threats:</h6>
                <li>
                Increased competition from established players recognizing 
                mobile eco-friendly automotive care market potential.
                </li>
                <li>
                Economic recession impacting commercial spending on automotive 
                services and partnership budget reductions.
                </li>
                <li>
                Partnership contract non-renewal risk as agreements reach 
                maturity requiring renegotiation.
                </li>
                <li>
                Regulatory changes affecting mobile automotive service operations 
                or environmental compliance requirements.
                </li>
                <li>
                Technology disruption in automotive care industry requiring 
                significant adaptation investment.
                </li>
              </p>
            </Tab>
            <Tab eventKey="tenth" title="Long-term Strategic Position (5-10 Years)">
              <p>
                <h6>Strengths:</h6>
                <li>
                Market leadership position in eco-friendly mobile automotive care 
                with established operational excellence and financial stability.
                </li>
                <li>
                Mature partnership network providing diversified revenue streams 
                and reduced dependency on single contract relationships.
                </li>
                <li>
                Proven franchise or licensing model generating sustainable passive 
                income through successful operational replication.
                </li>
                <li>
                Strong brand recognition and market reputation built through 
                decade of consistent service delivery and innovation.
                </li>
                <li>
                Comprehensive technology integration providing competitive 
                advantages in operational efficiency and customer experience.
                </li>
              </p>
              <p>
                <h6>Weaknesses:</h6>
                <li>
                Market maturity in core geographic regions limiting organic 
                growth opportunities without significant diversification.
                </li>
                <li>
                Increased operational complexity from managing multiple business 
                lines, partnerships, and potential franchise network.
                </li>
                <li>
                Technology and equipment obsolescence requiring continuous 
                investment to maintain competitive positioning.
                </li>
                <li>
                Management succession and business continuity challenges as 
                founder involvement transitions over time.
                </li>
                <li>
                Regulatory compliance complexity increasing with geographic 
                expansion and business model diversification.
                </li>
              </p>
              <p>
                <h6>Opportunities:</h6>
                <li>
                Strategic exit opportunities through trade sale, management buyout, 
                or strategic partnership maximizing business value.
                </li>
                <li>
                International expansion opportunities through established franchise 
                model or strategic partnerships in aligned markets.
                </li>
                <li>
                Diversification into complementary automotive or environmental 
                services leveraging established customer relationships.
                </li>
                <li>
                Technology licensing opportunities based on proprietary operational 
                systems and environmental solutions.
                </li>
                <li>
                Strategic acquisition opportunities to consolidate market position 
                or expand into adjacent service categories.
                </li>
              </p>
              <p>
                <h6>Threats:</h6>
                <li>
                Industry disruption from new technologies or business models 
                affecting traditional mobile automotive care demand.
                </li>
                <li>
                Economic recession significantly impacting commercial and consumer 
                spending on automotive services over extended period.
                </li>
                <li>
                Intense competition from well-funded new entrants or established 
                players expanding into eco-friendly mobile services.
                </li>
                <li>
                Regulatory changes affecting environmental standards, mobile 
                service operations, or franchise business models.
                </li>
                <li>
                Key personnel departure or succession planning failures affecting 
                business continuity and operational performance.
                </li>
              </p>
            </Tab>
          </Tabs>
        </div>
        <div className="column is-one-fifth fadeLeftMini"></div>
      </div>
    </section>
  </>
)
